/* Copyright (C) Okahu Inc 2023-2024. All rights reserved.*/
'use client';

import { useLanguage } from '@/providers/LanguageProvider';

import { CustomButton } from '../common';
import { KahuIcons, System } from '../icons/icons';

type KahuChattingErrorUiProps = {
  onClose: () => void;
};

export const KahuChattingErrorUi = ({ onClose }: KahuChattingErrorUiProps) => {
  const { messages } = useLanguage();
  const KahuAiString = messages?.KahuAI;

  return (
    <div className="h-full rounded-lg  bg-[linear-gradient(180deg,#257C9D_0%,#34BCAF_100%)] p-px">
      <main className="flex h-full w-[400px] flex-col justify-between rounded-lg bg-canvas-background-secondary">
        <div>
          {/* chat window header */}
          <div className="flex w-full items-center justify-between rounded-t-lg bg-[#257C9D] px-4 py-2">
            <div className="flex items-center gap-2">
              <span className="flex h-8 w-8 items-center justify-center rounded-full bg-[#0000008F] p-2">
                {KahuIcons.KahuInvocationIcon('w-6')}
              </span>
              <p className="text-h4 font-bold text-white">
                {KahuAiString?.hey_im_kahu}
              </p>
            </div>
            <div className="flex gap-0.5">
              <button
                className="group grid h-6 w-6 place-items-center rounded bg-transparent p-0 hover:bg-[#FFFFFF1F] active:bg-[#FFFFFF29]"
                onClick={onClose}
              >
                {KahuIcons.CloseIcon(
                  'text-[#C1C9CF] group-active:text-white group-hover:text-white'
                )}
              </button>
            </div>
          </div>
          {/* Main chat container */}
          <div className="mx-4 mb-8 mt-6 flex flex-col items-center">
            {/* icons goes here */}
            {System.InfoIcon('w-[51px] h-[51px] text-[#8C9EA1]')}
            <p className="mb-2 mt-[14.5px] text-center text-h4 font-medium  text-white">
              {KahuAiString?.kahu_is_temporarily_unavailable}
            </p>

            <p className="mb-5 text-center text-body font-normal text-body-subtle">
              {KahuAiString?.kahu_crash_detail_error_guide}
            </p>

            <CustomButton
              customSize="regular"
              customVariant="secondary"
              onClick={onClose}
            >
              Close Chat
            </CustomButton>
          </div>
        </div>
      </main>
    </div>
  );
};
